import classNames from 'classnames/bind';

import styles from './S03.module.scss';
import product01 from '../../../assets/images/products/water/product01.jpg';
import product02 from '../../../assets/images/products/water/product02.jpg';
import product03 from '../../../assets/images/products/water/product03.jpg';
import product04 from '../../../assets/images/products/water/product04.jpg';
import Nutrient from '../../../components/product/Nutrient';
import Products from '../../../components/product/Products';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <Products
          products={[
            { title: '2L', image: product01, text: '2L × 6개입' },
            { title: '1L', image: product02, text: '1L × 12개입' },
            { title: '500mL', image: product03, text: '500mL × 20개입' },
            { title: '330mL', image: product04, text: '330mL × 20개입' },
          ]}
          color="#06542c"
        />
        <Nutrient
          data={{
            head: ['칼슘(Ca)', '칼륨(K)', '불소(F)', '마그네슘(Mg)', '나트륨(Na)'],
            body: [['13.5 ~ 18.6', '0.4 ~ 0.6', '0.0 ~ 0.2', '2.0 ~ 2.4', '6.7 ~ 7.6']],
          }}
          color="#bed730"
        />
      </div>
    </div>
  );
};

export default S03;
